import { HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, shareReplay } from 'rxjs';
import { BaseResponseModel } from '../common/models/app.model';

import {
    AirportsGroup,
    CountryDDLModel,
    DropDownListCodeResponse,
    UserDDLResponse,
} from '@models/dropdown-list.model';
import { UserType } from '@models/user.model';
import { HttpService } from '@services/http.service';
@Injectable({
    providedIn: 'root',
})
export class DropdownService {
    private httpService = inject(HttpService);
    private airPortGroupMap = this.getAirPortDDLAsync().pipe(shareReplay(1));
    private allCountryDDL$ = this.getCountriesDDL().pipe(shareReplay(1));

    public getAirportDDL(): Observable<BaseResponseModel<AirportsGroup[]>> {
        return this.airPortGroupMap;
    }

    public getAllCountryDDL(): Observable<BaseResponseModel<CountryDDLModel[]>> {
        return this.allCountryDDL$;
    }

    public getCountriesDDL(): Observable<BaseResponseModel<CountryDDLModel[]>> {
        return this.httpService.get('DropDownList/GetCountryDDL');
    }

    public getListUserType(): Observable<BaseResponseModel<UserType[]>> {
        return this.httpService.get('DropDownList/GetListUserType', {
            params: new HttpParams({
                fromObject: {
                    getAll: false,
                },
            }),
        });
    }

    public getAirPortDDLAsync(): Observable<BaseResponseModel<AirportsGroup[]>> {
        return this.httpService.get('DropDownList/GetAirPortDDL');
    }

    /**
     * Get user DDL
     *
     * @param {string} userKey
     * @return {*}  {Observable<any[]>}
     * @memberof DropdownService
     */
    public getUserDDL(
        userKey: string,
        isCheckRole?: boolean
    ): Observable<BaseResponseModel<UserDDLResponse[]>> {
        return this.httpService.get('DropDownList/GetUserDDL', {
            params: new HttpParams({
                fromObject: {
                    key: userKey,
                    ...(isCheckRole && { isCheckRole: true }),
                },
            }),
        });
    }

    public getUserDDLByType(userTypeId: number): Observable<UserDDLResponse[]> {
        return this.httpService.get('DropDownList/GetUserDDLByType', {
            params: new HttpParams({
                fromObject: {
                    UserTypeId: userTypeId,
                },
            }),
        });
    }

    /**
     * Get group role by userId
     *
     * @param {number} userId
     * @return {*}
     * @memberof DropdownService
     */
    public getGroupRoleByUserDDL(userId: number): Observable<DropDownListCodeResponse[]> {
        return this.httpService.get('DropDownList/GetGroupRoleByUserDDL', {
            params: new HttpParams({
                fromObject: {
                    userId,
                },
            }),
        });
    }

    public getCabinDDL(): Observable<BaseResponseModel<DropDownListCodeResponse[]>> {
        return this.httpService.get('DropDownList/GetCabinDDL');
    }

    public getAirPortDDL(): Observable<BaseResponseModel<AirportsGroup[]>> {
        return this.httpService.get('DropDownList/GetAirPortDDL');
    }

    /**
     * Get Airline DDL
     *
     * @return {*}  {Observable<DropDownListCodeResponse[]>}
     * @memberof DropdownService
     */
    public getAirlineDDL(): Observable<BaseResponseModel<DropDownListCodeResponse[]>> {
        return this.httpService.get('DropDownList/GetAirlineDDL');
    }
    
    public getListUserTypeDDL(): Observable<BaseResponseModel<UserType[]>> {
        return this.httpService.get('DropDownList/GetListUserType');
    }
}
